<template>
	<div>
		<div>
			<breadcrumb :routerList="[{title:'采购项目'}]"/>
			<div class="h-content">
				<div class="h-row h-mrt0">
					<div class="h-rowIn">
						<div class="h-rowBox">
							<div class="h-rowCon">
								<div class="h-pieceIn2">
									<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
										<h1>基本信息</h1>
									</div>
									<div class="h-pieceCon2" style="padding:0">
										<div class="h-formLine initiate">
											<el-form :model="formLabelAlign" label-position="right" ref="cai"
													 :inline="true"
													 class="demo-ruleForm h-formbLine h-formbLine1">
												<el-form-item label="项目编号" class="h-elformWrap-2" prop="id">
													<el-input readonly v-model="formLabelAlign.id"></el-input>
												</el-form-item>
												<el-form-item label="项目名称" class="h-elformWrap-2" prop="projectName">
													<el-input readonly v-model="formLabelAlign.projectName"></el-input>
												</el-form-item>
												<el-form-item label="项目说明" class="h-elformWrap-1"
															  prop="projectDescription">
													<el-input readonly v-model="formLabelAlign.projectDescription"
															  maxlength="70" placeholder="请输入">
													</el-input>
												</el-form-item>
											</el-form>
										</div>
										<el-row :gutter="20">
											<el-col :span="12">
												<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
													<h1>产品信息</h1>
												</div>
												<el-table
														@selection-change="handleSelectionChange"
														ref="multipleTable"
														max-height="300"
														:border="true"
														:data="proProductwx"
														style="width: 100%">
													<el-table-column
															type="selection"
															:selectable="selectFlag"
															width="70"
															:label="all"
															@header-click="headerClick"
													>
													</el-table-column>
													<el-table-column
															prop="productId"
															label="产品编码"
															min-width="120"
															:show-overflow-tooltip="true">
													</el-table-column>
													<el-table-column
															prop="productName"
															label="产品型号"
															min-width="150"
															:show-overflow-tooltip="true">
													</el-table-column>
													<el-table-column
															prop="xuniFlag"
															label="产品类型">
														<template scope="scope">
															{{scope.row.xuniFlag|dictname('xuni_flag')}}
														</template>
													</el-table-column>
													<el-table-column
															prop="productDes"
															label="产品描述"
															min-width="150"
															:show-overflow-tooltip="true">
													</el-table-column>
												</el-table>
											</el-col>

											<el-col :span="12">
												<div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
													<h1>供应商信息</h1>
												</div>
												<div class="h-formBox" style="margin-bottom: -10.9px">
													<el-form :inline="true" :model="gysquery" class="demo-form-inline h-formBorder">
														<el-form-item label="供应商编码/名称">
															<el-input clearable v-model="gysquery.codeNameLike"></el-input>
														</el-form-item>
														<el-form-item class="h-formBtnOut">
															<el-button type="primary" @click="gysqueryPage">搜索</el-button>
															<el-button type="primary" @click="selectUser"  icon="el-icon-plus">全选</el-button>
														</el-form-item>
													</el-form>
												</div>
												<el-table
														@selection-change="handleSelectionChange"
														ref="multipleTable"
														max-height="400"
														:border="true"
														:data="optionsSupplier"
														style="width: 100%">
													<el-table-column
															type="selection"
															:selectable="selectFlag"
															width="70"
															:label="all"
															@header-click="headerClick"
													>
													</el-table-column>
													<el-table-column
															prop="usercode"
															min-width="90"
															label="供应商编码">
													</el-table-column>
													<el-table-column
															prop="userName"
															label="供应商名称"
															min-width="150"
															:show-overflow-tooltip="true">
													</el-table-column>
												</el-table>
												<paginationminNosize :page="gysquery" @query="gysqueryPage" style="padding-top: 0.1rem"/>
											</el-col>
										</el-row>

										<div>
											<div class="h-txtCenter h-mrt60">
												<!--                                                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelPro">取消-->
												<!--                                                </el-button>-->
												<el-button class="h-btn h-bBtn h-bgblueQ2" @click="addForms">选择供应商
												</el-button>
											</div>
										</div>
									</div>
								</div>
								<br/>
								<div class="N-chan">
									<div class="h-pieceTitle2">
										<h1>询价组信息</h1>
										<el-button size="small" type="primary"
												   icon="el-icon-circle-plus"
												   style="margin-left: 50px;" >添加询价组
										</el-button>
									</div>
									<el-table
											ref="multipleTable"
											:span-method="objectSpanMethod"
											:data="item"
											:border="true"
											style="width: 100%">
										<el-table-column
												type="index"
												width="40"
												label="#">
										</el-table-column>
										<el-table-column
												prop="productName"
												label="产品型号"
												width="220">
										</el-table-column>
										<el-table-column
												label="询价截止日期"
												width="160"
												:rules="[{ required: true, message: '请输入询价截止日期', trigger: 'blur'},]"
												prop="timeOut">
											<template scope="scope">
												<el-date-picker
														v-model="addForm[index].timeOut"
														type="date"
														style="width:100%;"
														:clearable="false"
														value-format="yyyy-MM-dd"
														placeholder="--选择--"
														:picker-options="timeOPT">
												</el-date-picker>
											</template>
										</el-table-column>
										<el-table-column
												prop="supplierHistory"
												label="已选择供应商"
												width="230">
											<template scope="scope">
												<el-select v-model="addForm[index].supplierHistory"
														   placeholder="--未选择--"
														   disabled
														   filterable
														   multiple
														   style="width:200px;"
														   size="large"
														   @change="changeSupplier">
													<el-option
															v-for="(item,index) in optionsSupplier"
															:key="index"
															:label="item.userName"
															:value="item.usercode">
													</el-option>
												</el-select>
											</template>
										</el-table-column>
										<el-table-column
												prop="supplierId"
												label="供应商名称"
												min-width="330">
											<template scope="scope">
												<el-select v-model="addForm[index].supplierId"
														   placeholder="--请选择--"
														   filterable
														   multiple
														   style="width:300px;"
														   size="large"
														   @change="changeSupplier">
													<!--                                                    @change="changeSupplier(scope.row,scope.$index)"-->
													<el-option
															v-for="(item,index) in optionsSupplier"
															:key="index"
															:label="item.userName"
															:value="item.usercode">
													</el-option>
												</el-select>
											</template>
										</el-table-column>
										<el-table-column
												label="操作"
												width="100"
												fixed="right">
											<template slot-scope="scope">
												<el-button
														type="text"
														size="small"
														class="h-tableLink h-btn"
														@click="deleteRow(index)">
													删除
												</el-button>
												<!-- <div class="l-operationBox">
													<span class="l-operationlist br-operation-delete" title="删除" @click="deleteRow(index)"></span>
												</div> -->
											</template>
										</el-table-column>
									</el-table>

								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="h-txtCenter h-mrt60">
					<el-button class="h-btn h-bBtn h-bgwhite" @click="cancelPro">返回</el-button>
					<el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitNew">确认提交</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                all: '全部',
                timeOut: null,
                timeOPT: this.timePicker(),
                proProductwx: [],
                formLabelAlign: {},
                info: {},
                infoList: [],
                optionsSupplier: [],
                supplier: [{supplierId: ''}],
                norepeat: [],
                addForm: [],
                multipleSelection: [],
                spanArr: [],
                rowNum: 0,
                gysquery:{
                    pageSize: 8,
                    pageNo: 1,
                    total: 0,
                    codeNameLike:null,
				}
            }
        },
        created() {
            this.gysqueryPage();
        },
        methods: {
            gysqueryPage() {
                ss.ProService.selectCaiGouListPage(this.gysquery).then(rd => {
                    console.log(rd);
                    this.gysquery.total = rd.total;
                    this.optionsSupplier = rd.records;
                })
            },

        }
    }

</script>

